export default "/assets/images/awards-celebration.ade6a3301539214e.mp4";